import { render, staticRenderFns } from "./BenutzerSC.vue?vue&type=template&id=66464a1b&scoped=true&"
import script from "./BenutzerSC.vue?vue&type=script&lang=js&"
export * from "./BenutzerSC.vue?vue&type=script&lang=js&"
import style0 from "./BenutzerSC.vue?vue&type=style&index=0&id=66464a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66464a1b",
  null
  
)

export default component.exports